import { ArrowRightIcon } from "@phosphor-icons/react";

import { cn } from "@/lib/utils";

/**
 * The frames' "Medium-40" buttons (`16204:290230`, `16156:290154`): filled
 * brand, or ghost. Used by the intro, "What you can do" and "Let’s jump in!".
 */
const OnboardingActionButton = ({
  variant,
  label,
  withArrow = false,
  onClick,
  className,
}: {
  variant: "primary" | "ghost";
  label: string;
  withArrow?: boolean;
  onClick: () => void;
  className?: string;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "focus-blue flex min-h-10 min-w-10 shrink-0 items-center justify-center gap-1.5 rounded-lg py-2.5 transition-colors label-m-medium",
      variant === "primary"
        ? "bg-bg-brand-primary-default text-fg-neutral-onFilled hover:bg-bg-brand-primary-hover active:bg-bg-brand-primary-active"
        : "bg-bg-brand-ghost-default text-fg-neutral-strong hover:bg-bg-brand-ghost-hover active:bg-bg-brand-ghost-active",
      withArrow ? "pl-3 pr-2.5" : "px-2.5",
      className,
    )}
  >
    {label}
    {withArrow ? <ArrowRightIcon size={20} aria-hidden="true" /> : null}
  </button>
);

export default OnboardingActionButton;
